import script from "./HeroPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroPage.vue?vue&type=script&setup=true&lang=js"

import "./HeroPage.vue?vue&type=style&index=0&id=75985af6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75985af6"]])

export default __exports__